import ELEMENT from 'common/element';
import { ACCESS_OPTIONS_MAP } from 'components/userAccounts/consts';
import Table from 'components/common/Table/Table';
import { Group } from 'components/manageGroups/ManageGroupsPage';
import Button from 'components/common/Button/Button';

type GroupsTableProps = {
  groups: Array<Group>;
  handleEdit: (group: Group) => void;
};

const TABLE_HEADERS = [
  { content: 'Name', field: 'name' },
  { content: 'Members', field: 'members' },
  { content: 'Permission', field: 'permission' },
  { content: 'Actions', field: 'actions' },
];

/**
 * Table component that renders list of groups managed in Okta/ Azure SCIM
 */
const GroupsTable = ({ groups, handleEdit }: GroupsTableProps) => {
  if (groups.length === 0) {
    return (
      <div>
        <p>No Groups available for this account.</p>
      </div>
    );
  }

  const tableData = groups.map((row) => ({
    name: row.displayName,
    members: row.totalMembers,
    permission: ACCESS_OPTIONS_MAP[row.permission],
    actions: <Button onClick={(): void => handleEdit(row)}>Edit Permission</Button>,
  }));

  return (
    <div className="GroupsTable" data-test-id={ELEMENT.manageGroupsTable}>
      <Table headers={TABLE_HEADERS} data={tableData} />
    </div>
  );
};

export default GroupsTable;
